import React from "react";
import {Redirect} from "react-router-dom";
import queryString from "query-string";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row
} from "reactstrap";

import apiRequest from "lib/Api";
import {saveAuth} from "lib/Auth";
import withNotify from "lib/NotificationWrapper";
import InputError from "views/components/InputError";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.requestEmail,
      password: '',
      password_confirmation: '',
      working: false,
      errors: {},
      loggedIn: false
    }
  }

  componentDidMount() {
    document.body.classList.toggle("login-page");
  }

  componentWillUnmount() {
    document.body.classList.toggle("login-page");
  }

  get token() {
    if (this.props.match.params) {
      return this.props.match.params.token;
    }
    return null;
  }

  get requestEmail() {
    let qs = this.props.location.search || '';
    if (qs) {
      let params = queryString.parse(qs);
      if (params.email) {
        return params.email;
      }
    }
    return null;
  }

  handleChange = (e) => {
    let {name, value} = e.target;
    this.setState({[name]: value});
  }

  clearForm() {
    this.setState({
      email: '',
      password: '',
      password_confirmation: '',
      errors: {},
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();

    let {email, password, password_confirmation} = this.state;
    let data = {email, password, password_confirmation, token: this.token};

    this.setState({working: true});

    apiRequest("/auth/reset-password", {data})
      .then(response => {
        this.props.notify({type: 'success', message: 'Sua senha foi alterada com sucesso.'});
        saveAuth(response.data);
        this.setState({loggedIn: true});
      })
      .catch(err => {
        this.setState({errors: err.data.errors || {email: 'E-mail inválido'}});
      })
      .finally(
        response => this.setState({working: false})
      );
  }

  render() {
    if (this.state.loggedIn) {
      return <Redirect to="/admin/dashboard" />;
    }

    let hasError = InputError.convertToHasClass(this.state.errors);

    return (
      <div className="login-page">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="4" md="6">
              <Form action="" className="form" method="POST"
                onSubmit={this.handleSubmit}
              >
                <Card className="card-login">
                  <CardHeader>
                    <CardHeader>
                      <h3 className="header text-center">Nova senha</h3>
                    </CardHeader>
                  </CardHeader>
                  <CardBody>
                    <FormGroup className={hasError.email}>
                      <InputGroup style={{marginBottom:0}}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-single-02" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Email..." type="text"
                          name="email"
                          value={this.state.email}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputError name="email" errors={this.state.errors} />
                    </FormGroup>
                    <FormGroup className={hasError.password}>
                      <InputGroup style={{marginBottom:0}}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Senha" type="password" name="password"
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputError name="password" errors={this.state.errors} />
                    </FormGroup>
                    <FormGroup className={hasError.password_confirmation}>
                      <InputGroup style={{marginBottom:0}}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Confirme a senha" type="password"
                          name="password_confirmation"
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputError name="password_confirmation" errors={this.state.errors} />
                    </FormGroup>
                    <br />
                  </CardBody>
                  <CardFooter>
                    <Button
                      block
                      className="btn-round mb-3"
                      color="warning"
                      disabled={this.state.working}
                    >
                      Alterar nova senha
                    </Button>
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("assets/img/bg/background-login.png")})`
          }}
        />
      </div>
    );
  }
}

export default withNotify(ResetPassword);
